import { Dispatch, SetStateAction, useState } from 'react';
import { useAsync } from 'react-use';

import { pageChanged } from '@/hooks/usePageChanged';
import { ConciergePulldownApi } from '@/infrastructures/api/common/ConciergePullDownApi';
import { Concierge } from '@/valueObjects/common/ConciergePulldownValueObject';

/** コンシェルジュのlistの選択肢 */
export let conciergeList: Concierge[];
let setConciergeList: Dispatch<SetStateAction<Concierge[]>>;

/** コンシェルジュのlistを一覧で取得 */
export const useConciergeList = () => {
  [conciergeList, setConciergeList] = useState([] as Concierge[]);
  useAsync(async () => {
    const conciergeListRes = await ConciergePulldownApi.post();
    if (conciergeListRes !== null)
      setConciergeList(conciergeListRes.map((conciergeData) => new Concierge(conciergeData)));
  }, [pageChanged]);
};

export const getNameOfConcierge = (id: number) =>
  conciergeList?.find((concierge) => concierge.value === id)?.text ?? '';

export const getIdOfConcierge = (name: string) =>
  conciergeList?.find((concierge) => concierge.text.replace(/\s/g, '') === name.replace(/\s/g, ''))?.value ?? -1;
